<template>
  <power-bi code="eyJrIjoiNDAzNGQ2MzYtMjc5MC00NDNhLTgxNDYtOTJjNzc0YjQzMGRhIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
